<template>
  <div class="w-full">
    <div v-if="url" class="w-full">
      <AudioMessage :audio-url="url" :duration="duration" :sent="isSent" />
    </div>
    <div v-else class="flex items-center gap-3 py-2">
      <div
        class="flex-shrink-0 w-11 h-11 rounded-full flex items-center justify-center"
        :class="
          isSent
            ? 'bg-white/25 dark:bg-[var(--p-primary-100)]/15'
            : 'bg-neutral-800/10 dark:bg-neutral-200/10'
        "
      >
        <Volume2
          :size="20"
          :class="
            isSent
              ? 'text-white dark:text-[var(--p-primary-50)]'
              : 'text-[var(--p-surface-900)] dark:text-[var(--p-surface-0)]'
          "
        />
      </div>
      <div class="flex-1 grid grid-rows-3 gap-0 min-w-0" style="height: 44px">
        <div></div>
        <div
          class="relative h-2 rounded-full overflow-hidden self-center"
          :class="
            isSent
              ? 'bg-white/35 dark:bg-[var(--p-primary-100)]/25'
              : 'bg-neutral-800/10 dark:bg-neutral-200/10'
          "
        >
          <div
            :class="[
              'absolute inset-y-0 left-0 rounded-full w-0',
              isSent
                ? 'bg-white/90 dark:bg-[var(--p-primary-100)]/85'
                : 'bg-neutral-800/80 dark:bg-neutral-200/60',
            ]"
          />
        </div>
        <div
          class="text-xs font-medium tracking-wide text-right self-start"
          :class="
            isSent
              ? 'text-white/80 dark:text-[var(--p-primary-100)]/80'
              : 'text-[var(--p-surface-700)] dark:text-[var(--p-surface-300)]'
          "
        >
          <span>{{ fileName || 'Audio' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Volume2 } from 'lucide-vue-next'
import AudioMessage from '../../atoms/audio/AudioMessage.vue'

interface Props {
  url?: string
  fileName?: string
  duration?: number
  isSent: boolean
}

defineProps<Props>()
</script>
